import { render, staticRenderFns } from "./SettingsDelegationRateCustom.vue?vue&type=template&id=5974d7c8&scoped=true&"
import script from "./SettingsDelegationRateCustom.vue?vue&type=script&lang=js&"
export * from "./SettingsDelegationRateCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5974d7c8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VAlert,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5974d7c8')) {
      api.createRecord('5974d7c8', component.options)
    } else {
      api.reload('5974d7c8', component.options)
    }
    module.hot.accept("./SettingsDelegationRateCustom.vue?vue&type=template&id=5974d7c8&scoped=true&", function () {
      api.rerender('5974d7c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/delegation-rate/SettingsDelegationRateCustom.vue"
export default component.exports